import { Avatar, Paper, Typography } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import * as constants from "../../../Components/constants";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Link from "next/link";
import style from "./GroupLeft.module.css";
import AddIcon from "@mui/icons-material/Add";
import GroupCreateModal from "../GroupCreateModal";
import GroupModal from "../../ModalContent/GroupModal/GroupModal";

const BASE_URL = constants.BASE_URL;

const fontStyle = {
  fontWeight: "600",
  fontSize: "14px",
  paddingBottom: "10px",
};
const icon = {
  fontSize: "26px",
};

const GroupLeft = ({
  singleGroup,
  isLoggedIn,
  localStoreId,
  userID,
  groupOwner,
}) => {
  const [groups, setGroups] = useState("");
  const [open, setOpen] = React.useState(false);
  const [myGroup, setMyGroup] = React.useState("");
  const [noGroup, setNoGroup] = React.useState("");
  const [openGroup, setGroup] = React.useState(false);

  console.log(userID);

  const handleClose = () => {
    setOpen(false);
  };

  const handleGroupClose = () => {
    setGroup(false);
  };

  //Other Group Getting Here
  useEffect(() => {
    fetch(`${BASE_URL}/group/all-groups/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let shuffled = data
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);
        setGroups(shuffled.slice(0, 100));
      });
  }, []);

  //My Group Getting Here
  const handleOwnGroup = () => {
    fetch(`${BASE_URL}/group/${localStorage.getItem("id")}/my-groups/`, {
      method: "GET",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.length !== undefined) {
          setMyGroup(data);
        } else {
          setNoGroup(data.message);
        }
      });
  };

  // getting my-groups data
  React.useEffect(() => {
    handleOwnGroup();
  }, [userID]);

  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <Paper className={`${style.left_position}  p-3 pb-5`} elevation={0}>
        {singleGroup && (
          <>
            <div className="d-flex align-items-center p-2">
              <Avatar
                style={{
                  border: "1px solid gray",
                  objectFit: "cover",
                  width: "60px",
                  height: "60px",
                }}
                alt={singleGroup.name}
                src={singleGroup.profile_pic}
              />
              <b className="px-2">
                {singleGroup.name ? singleGroup.name : "Group Name"}{" "}
                {singleGroup.is_verified && (
                  <VerifiedIcon color="primary" sx={{ fontSize: "20px" }} />
                )}
              </b>
            </div>

            <hr />
          </>
        )}

        <div
          onClick={() => setOpen(true)}
          className={`${style.create_box} d-flex align-itmes-start justify-content-center p-1`}
        >
          <AddIcon className={`${style.plus_icon}`} />
          <small className={`${style.new_group}`}>Create New Group</small>
        </div>

        <hr />

        <div className="px-4">
          {isLoggedIn && (
            <Link
              href={`/user/${localStorage.getItem("id")}`}
              passHref
              legacyBehavior
            >
              <a style={fontStyle} className="d-block">
                <AccountCircleOutlinedIcon style={icon} />
                <span className="text-dark"> Your Profile </span>
              </a>
            </Link>
          )}

          <Link href="/group/home" passHref legacyBehavior>
            <a style={fontStyle} className="d-block">
              <GroupOutlinedIcon style={icon} />{" "}
              <span className="text-dark"> Groups</span>
            </a>
          </Link>
          <Link href="/course" passHref legacyBehavior>
            <a style={fontStyle} className="d-block">
              <SchoolOutlinedIcon style={icon} />{" "}
              <span className="text-dark"> Courses</span>
            </a>
          </Link>

          {groupOwner === "Creator" && (
            <Link href={`/group/wallet/${singleGroup.id}`} passHref>
              <a style={fontStyle} className="d-block">
                <AccountBalanceWalletOutlinedIcon style={icon} />{" "}
                <span className="text-dark"> Group Wallet</span>
              </a>
            </Link>
          )}

          <span
            className={`${style.create} d-block`}
            onClick={() => setGroup(true)}
          >
            <PostAddRoundedIcon style={icon} />{" "}
            <span className="text-dark">Create Course</span>
          </span>

          <Link
            href={`/research-solutions`}
            scroll={true}
            passHref
            legacyBehavior
          >
            <a style={fontStyle} className="d-block">
              <PlagiarismOutlinedIcon style={icon} />{" "}
              <span className="text-dark">Research Soluation</span>
            </a>
          </Link>

          <Link href={`/ictsolution`} passHref legacyBehavior>
            <a style={fontStyle} className="d-block">
              <TravelExploreIcon style={icon} />{" "}
              <span className="text-dark">ICT Soluation</span>
            </a>
          </Link>

          {userID == 4 || userID == 10 ? (
            <Link href="/admin/payment-status" passHref legacyBehavior>
              <a style={fontStyle} className="d-block">
                <AdminPanelSettingsIcon style={icon} />{" "}
                <span className="text-dark">Admin Dashboard</span>
              </a>
            </Link>
          ) : null}
        </div>

        {isLoggedIn && myGroup && (
          <>
            <hr />
            <div className="d-flex justify-content-between pb-3">
              <span className="fs-6 fw-bold">Groups you manage</span>
              <ManageAccountsIcon />
            </div>

            {myGroup.map((group, idx) => (
              <div
                key={idx}
                className={`${style.cursor} d-flex align-items-center my-3`}
              >
                <Link href={`/group/${group.id}`}>
                  <Avatar
                    sx={{
                      ml: 1,
                      width: 48,
                      height: 48,
                      border: 1,
                      borderColor: "grey.500",
                      cursor: "pointer",
                    }}
                    src={group.profile_pic}
                    alt={group.name}
                  />
                </Link>

                <Link href={`/group/${group.id}`}>
                  <a className="d-flex flex-column mx-2 text-dark">
                    <small
                      className="d-inline-block text-truncate fw-bold"
                      style={{ maxWidth: "150px" }}
                    >
                      {group.name}{" "}
                      {group.is_verified && (
                        <VerifiedIcon
                          color="primary"
                          sx={{ fontSize: "20px" }}
                        />
                      )}
                    </small>

                    <small
                      className="d-inline-block text-truncate"
                      style={{ maxWidth: "150px" }}
                    >
                      {group.about}
                    </small>
                  </a>
                </Link>
              </div>
            ))}
          </>
        )}

        <hr />

        <div className="d-flex justify-content-between pb-3">
          <span className="fs-6 fw-bold">Add to your feed</span>
          <GroupAddIcon />
        </div>
        {!groups ? (
          <p>Loading...</p>
        ) : (
          <div className={`${style.my_group}`}>
            {groups.map((group, idx) => (
              <div
                key={idx}
                className={`${style.cursor} d-flex align-items-center my-3`}
              >
                <Link href={`/group/${group.id}`}>
                  <Avatar
                    sx={{
                      ml: 1,
                      width: 45,
                      height: 45,
                      border: 1,
                      borderColor: "grey.500",
                      cursor: "pointer",
                    }}
                    src={group.profile_pic}
                    alt={group.name}
                  />
                </Link>
                <Link href={`/group/${group.id}`}>
                  <a className="d-flex flex-column mx-2 text-dark">
                    <small
                      className="d-inline-block text-truncate fw-bold"
                      style={{ maxWidth: "150px", cursor: "pointer" }}
                    >
                      {group.name}{" "}
                      {group.is_verified && (
                        <VerifiedIcon
                          color="primary"
                          sx={{ fontSize: "20px" }}
                        />
                      )}
                    </small>

                    <small
                      className="d-inline-block text-truncate"
                      style={{ maxWidth: "150px" }}
                    >
                      {group.about}
                    </small>
                  </a>
                </Link>
              </div>
            ))}
          </div>
        )}

        <Link href={`/group/discover`}>
          <div
            className={`${style.more_group} py-3 mx-2`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Avatar
              sx={{
                bgcolor: isHovered ? "#4284ff" : "text.secondary",
                width: 40,
                height: 40,
              }}
            >
              <GroupsIcon size="small" />
            </Avatar>
            <Typography
              className="mx-2"
              variant="caption"
              fontWeight={600}
              fontSize={14}
              sx={{
                color: isHovered ? "#4284ff" : "inherit",
              }}
            >
              See all groups
            </Typography>
          </div>
        </Link>
      </Paper>

      <>
        <GroupCreateModal
          open={open}
          handleClose={() => handleClose()}
          handleOwnGroup={handleOwnGroup}
        />
        <GroupModal
          open={openGroup}
          handleClose={() => handleGroupClose()}
          localStoreId={localStoreId}
          userID={userID}
        />
      </>
    </>
  );
};

export default GroupLeft;
